var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"common-page__container"},[_c('v-row',[_c('v-col',[_c('h2',[_vm._v("Check your inbox to activate your account.")])])],1)],1),_c('div',{staticClass:"common-background__svg"},[_c('img',{attrs:{"src":_vm.backgroundImage}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }